export const FeatureItems = {
    AGENT: "agent",
    ARCHIVE: "archive",
    CHAT: "chat",
    CHATBOT: "chatbot",
    REPORT: "report",
    SUPPORT: "support",
    SYSTEM: "system",
    TRIGGERS: "triggers",
    WHATSAPP: "whatsapp",
    TEAM_CHAT: "teamChat",
    MAIL: "mail",
    SMS: "sms",
    INSTAGRAM: "instagram",
    MESSENGER: "messenger",
    SERVICES: "services",
};

export const Features = {
    AGENT: {
        FREE_AGENT_COUNT: "freeAgentCount",
        AGENT_COUNT: "agentCount",
    },
    ARCHIVE: {
        MAX_CHAT_ARCHIVE_TIME: "maxChatArchiveTime",
        CHAT_ARCHIVE_TIME: "chatArchiveTime",
    },
    CHAT: {
        AUTO_TRANSLATION: "autoTranslation",
        VOICE_CALLING: "voiceCalling",
        VIDEO_CALLING: "videoCalling",
        FILE_AND_VOICE_MESSAGE: "fileAndVoiceMessage",
        COPILOT: "chatCopilot",
    },
    CHATBOT: {
        MAX_SESSION_COUNT: "maxSessionCount",
        STORY_COUNT_LIMIT: "storyCountLimit",
        INTEGRATION_COUNT: "integrationCount",
        VERSION_HISTORY_COUNT: "versionHistoryCount",
        CHATBOT_BUTTON_ACTIVITY: "chatbotButtonActivity",
        ACTIVE_CHATBOT_LIMIT: "activeChatbotLimit",
    },
    REPORT: {
        REPORT: "report",
        VISITOR_TRACKING: "visitorTracking",
        SPECIAL_REPORT: "specialReport",
    },
    SUPPORT: {
        SUPPORT: "support",
        SOFTWARE_SUPPORT: "softwareSupport",
        DEDICATED_CUSTOMER_SUPPORT: "dedicatedCustomerSupport",
    },
    SYSTEM: {
        CHAT_AND_NOTIFICATION: "chatAndNotification",
        CHAT_BALLOON_CUSTOMIZATION: "chatBalloonCustomization",
        REMOVE_SUPSIS_LOGO: "removeSupsisLogo",
        DATABASE_CONNECTION: "databaseConnection",
        SINGLE_PANEL_ACCESS: "singlePanelAccess",
        TICKET_SYSTEM: "ticketSystem",
        CHATBOT_ENTEGRATION: "chatbotEntegration",
        TEAM_CHAT_ENTEGRATION: "teamChatEntegration",
        WHATSAPP_ENTEGRATION: "whatsappEntegration",
        INSTAGRAM_ENTEGRATION: "instagramEntegration",
        MESSENGER_ENTEGRATION: "messengerEntegration",
        TELEGRAM_ENTEGRATION: "telegramEntegration",
        MAIL_ENTEGRATION: "mailEntegration",
        SMS_ENTEGRATION: "smsEntegration",
        WEBHOOK_ENTEGRATION: "webhookEntegration",
        CALENDER_ENTEGRATION: "calenderEntegration",
        TASK_MANAGEMENT_ENTEGRATION: "taskManagementEntegration",
        ALL_ENTEGRATION: "allEntegrations",
        ACCESS_ALL_AGENT: "accessAllAgent",
        VISITOR_START_CHAT: "visitorStartChat",
        DATA_PROTECT: "dataProtect",
        READY_CONTENTS: "readyContents",
        PERMISSION_CONTROL: "permissionControl",
        AUTO_REZERVATION: "autoRezervation",
        FLEXIBLE_BILLING: "flexibleBilling",
        MAX_DISK_SIZE: "maxDiskSize",
    },
    TRIGGERS: {
        MAX_TRIGGER_COUNT: "maxTriggerCount",
    },
    WHATSAPP: {
        CHANNEL_COUNT: "channelCount",
        BUSINESS_CHANNEL_COUNT: "businessChannelCount",
        BROADCAST_PER_MESSAGE: "broadcastPerMessage",
        BULK_MESSAGE_SENDING: "bulkMessageSending",
        MESSAGE_UNREGISTERED_NUMBERS: "messageUnregisteredNumbers",
        PERSONALIZED_BROADCAST_MESSAGE: "personalizedBroadcastMessage",
        CONTROL_WHATSAPP: "controlWhatsapp",
        WHATSAPP_CHATBOT_ENTEGRATION: "whatsappChatbotEntegration",
        NOT_ADDITIONAL_PRICE: "notAdditionalPrice",
    },
    TEAM_CHAT: {},
    MAIL: {},
    SMS: {},
    SERVICES: {
        FLEXIBLE_PRICING: "flexiblePricing",
        UNLIMITED_CB_SCENARIO: "unlimitedCBScenario",
        FREE_FIRST_SCENARIO: "freeFirstScenario",
        RIGHT_TO_CANCEL: "rightToCancel",
        UNLIMITED_LEARN: "unlimitedLearn",
        ALL_PLATFORM_INTEGRATION: "allPlatformIntegration",
        AI_SUPPORT: "aiSupport",
        CREATIVE_AI: "creativeAI",
        UNLIMITED_SESSION: "unlimitedSession",
        ASSISTANT_FROM_WEB: "assistantFromWebsite",
        ASSISTANT_FROM_DOC: "assistantFromDoc",
        MOBILE_APP: "mobileApp",
        WHATSAPP: "whatsapp",
        EMAIL: "email",
        WEB: "web",
        INSTAGRAM: "instagram",
        MESSENGER: "messenger",
        MANAGE_INBOX: "manageInbox",
        COMMENT_MANAGEMENT: "commentManagement",
        PRIVATE_REPLY_MESSAGE: "privateReplyMessage",
        MENTION_TICKET: "mentionTicket",
        MANAGE_WITH_CHATBOT: "manageWithChatbot",
    },
    INSTAGRAM: {
        CHANNEL_COUNT: "instagramChannelCount",
    },
    MESSENGER: {
        CHANNEL_COUNT: "messengerChannelCount",
    },
};
